import React from 'react';
import { useBrandingColors } from '../../hooks/useBrandingColors';

interface InterviewCreationFormProps {
  selectedPositionId: number | null;
  interviewFormData: {
    candidateFirstName: string;
    candidateLastName: string;
    candidateEmail: string;
  };
  handleInterviewFieldChange: (field: string, value: string) => void;
  handleCreateInterviewSubmit: () => void;
}

export function InterviewCreationForm({
  selectedPositionId,
  interviewFormData,
  handleInterviewFieldChange,
  handleCreateInterviewSubmit,
  onBack
}: InterviewCreationFormProps & { onBack: () => void }) {
  const [showErrors, setShowErrors] = React.useState(false);
  const colors = useBrandingColors();
  return (
    <div className="bg-[#f5f6f1] rounded-[24px] p-6 w-full">
      <div className="space-y-6">
        <div className="flex items-center justify-between">
          <h2 className="text-[24px] font-semibold text-[#000000]">
            Создать интервью
          </h2>
          <button
            onClick={onBack}
            className="transition-colors text-[15px] font-medium"
            style={{ color: colors.primary }}
            onMouseEnter={(e) => (e.currentTarget.style.color = colors.primaryHover)}
            onMouseLeave={(e) => (e.currentTarget.style.color = colors.primary)}
          >
            ← Назад к вакансиям
          </button>
        </div>

        {!selectedPositionId && (
          <div className="bg-[#fff3cd] border border-[#ffeaa7] rounded-lg p-4">
            <div className="text-[#856404] text-[14px]">
              Выберите вакансию слева для добавления кандидата
            </div>
          </div>
        )}

        <div className="bg-[#ffffff] rounded-[32px] p-6 space-y-6">
          {/* Candidate First Name */}
          <div className="space-y-2">
            <label className="text-[16px] font-medium text-[#0a0d14]">
              Имя кандидата *
            </label>
            <input
              type="text"
              value={interviewFormData.candidateFirstName}
              onChange={(e) => handleInterviewFieldChange('candidateFirstName', e.target.value)}
              className="w-full pl-[16px] pr-[12px] py-[12px] border border-[#e2e4e9] rounded-[30px] text-[16px] text-[#525866] focus:outline-none placeholder:text-[#525866]"
              onFocus={(e) => { e.currentTarget.style.borderColor = 'var(--brand-primary, #e16349)'; }}
              onBlur={(e) => { e.currentTarget.style.borderColor = '#e2e4e9'; }}
              placeholder="Введите имя кандидата"
            />
          </div>

          {/* Candidate Last Name */}
          <div className="space-y-2">
            <label className="text-[16px] font-medium text-[#0a0d14]">
              Фамилия кандидата *
            </label>
            <input
              type="text"
              value={interviewFormData.candidateLastName}
              onChange={(e) => handleInterviewFieldChange('candidateLastName', e.target.value)}
              className="w-full pl-[16px] pr-[12px] py-[12px] border border-[#e2e4e9] rounded-[30px] text-[16px] text-[#525866] focus:outline-none placeholder:text-[#525866]"
              onFocus={(e) => { e.currentTarget.style.borderColor = 'var(--brand-primary, #e16349)'; }}
              onBlur={(e) => { e.currentTarget.style.borderColor = '#e2e4e9'; }}
              placeholder="Введите фамилию кандидата"
            />
          </div>

          {/* Candidate Email */}
          <div className="space-y-2">
            <label className="text-[16px] font-medium text-[#0a0d14]">
              Email кандидата *
            </label>
            <input
              type="email"
              value={interviewFormData.candidateEmail}
              onChange={(e) => handleInterviewFieldChange('candidateEmail', e.target.value)}
              className="w-full pl-[16px] pr-[12px] py-[12px] border border-[#e2e4e9] rounded-[30px] text-[16px] text-[#525866] focus:outline-none placeholder:text-[#525866]"
              onFocus={(e) => { e.currentTarget.style.borderColor = 'var(--brand-primary, #e16349)'; }}
              onBlur={(e) => { e.currentTarget.style.borderColor = '#e2e4e9'; }}
              placeholder="Введите email кандидата"
            />
          </div>



          {/* Validation Errors */}
          {(() => {
            const errors: string[] = [];
            if (!selectedPositionId) errors.push('• Выберите вакансию для создания интервью');
            if (!interviewFormData.candidateFirstName) errors.push('• Введите имя кандидата');
            if (!interviewFormData.candidateLastName) errors.push('• Введите фамилию кандидата');
            if (!interviewFormData.candidateEmail) {
              errors.push('• Введите email кандидата');
            } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(interviewFormData.candidateEmail)) {
              errors.push('• Введите корректный email адрес');
            }

            if (!showErrors || errors.length === 0) return null;

            return (
              <div className="bg-[#fef2f2] border border-[#fecaca] rounded-lg p-3">
                <div className="text-[#dc2626] text-[14px] space-y-1">
                  {errors.map((error, index) => (
                    <div key={index}>{error}</div>
                  ))}
                </div>
              </div>
            );
          })()}

          {/* Submit Button */}
          <button
            onClick={() => {
              // показываем ошибки после первой попытки сохранения
              setShowErrors(true);
              handleCreateInterviewSubmit();
            }}
            className="ml-auto w-auto bg-[#e16349] text-white px-[12px] py-[12px] rounded-[30px] text-[16px] h-[52px] hover:bg-[#d14a31] transition-colors"
          >
            Создать интервью
          </button>
        </div>
      </div>
    </div>
  );
} 